import React, { useMemo, useState } from "react";
import Grid from "@mui/material/Grid";
import casePdfGeneratorStyle from "./casePdfGeneratorStyle";
import _ from "lodash";
import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import ButtonLoading from "../../Button/ButtonLoading";
import { previewCaseFile } from "../../../services/Files/fileService";
import { MediaObject } from "../../../types/MediaObject";
import { ProductUnion } from "../../../types/ProductUnion";
import { Box } from "@mui/material";

type PdfGeneratorPreviewProps = {
  product: ProductUnion;
  values: Record<string, any>;
  mediaObjects: MediaObject[];
  getParams: Function;
  documentIdentifier?: string;
  disabled?: boolean;
};

const PdfGeneratorPreview = ({
  product,
  values,
  mediaObjects,
  getParams,
  documentIdentifier = "customPdf",
  disabled,
}: PdfGeneratorPreviewProps) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewSrc, setPreviewSrc] = useState("");
  const [previewIsLoading, setPreviewIsLoading] = useState(false);

  const summedMediaObjectsSize = useMemo(() => {
    let totalMediaObjectSize = 0;

    if (!mediaObjects.length) {
      return 0;
    }

    _.forEach(values.selectedMediaObjects, (selectedMediaObject) => {
      totalMediaObjectSize +=
        _.find(mediaObjects, (mediaObject) => mediaObject.id === selectedMediaObject)?.["size"] || 0;
    });
    return totalMediaObjectSize;
  }, [values.selectedMediaObjects]);

  const generatePreview = async () => {
    setPreviewIsLoading(true);
    const previewSrc = await previewCaseFile({
      product: product,
      documentType: "pdf",
      documentIdentifier: documentIdentifier,
      params: getParams(),
    });
    setPreviewSrc(previewSrc);
    setPreviewOpen(true);
    setPreviewIsLoading(false);
  };

  const previewFileSizeLimitReached = summedMediaObjectsSize > 1500000;

  return (
    <Grid
      container
      spacing={3}
      sx={{
        alignItems: "center",
        justifyContent: "center"
      }}>
      <Grid sx={casePdfGeneratorStyle.buttonContainer} size={12}>
        {previewFileSizeLimitReached ? (
          <Box sx={casePdfGeneratorStyle.fileSizeWarning}>Vorschau nicht verfügbar - Anhang zu groß</Box>
        ) : (
          <>
            <ButtonLoading
              sx={casePdfGeneratorStyle.previewButton}
              variant={"text"}
              fullWidth={false}
              onClick={generatePreview}
              isLoading={previewIsLoading}
              disabled={previewFileSizeLimitReached || disabled}
            >
              Vorschau anzeigen
            </ButtonLoading>
            <LegalbirdIoModal
              handleClose={() => setPreviewOpen(false)}
              open={previewOpen}
              title={"Vorschau"}
              hasActions={false}
              maxWidth={"xl"}
            >
              <Box sx={casePdfGeneratorStyle.imageContainer}>
                <Box sx={casePdfGeneratorStyle.embedContainer}>
                  <embed src={previewSrc} type="application/pdf" width="100%" height="100%" />
                </Box>
              </Box>
            </LegalbirdIoModal>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default PdfGeneratorPreview;
